import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  ColorLens as ColorLensIcon
} from '@material-ui/icons';


const FontFormatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <rect y="0.441162" width="24" height="24" fill="url(#pattern0)" />
    <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_6_586" transform="scale(0.0104167)" />
      </pattern>
      <image id="image0_6_586" width="96" height="96" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAEcUlEQVR4nO2cTYsdRRSG3yPXxbgZ3E0iKAxK1sa9SZa6iCBuhKAG8UeJSlQU3ajEP+DoXiFLjQYiJONKzcIEzJjHxb2Do6aruqvrs289mxno6rrnVvU5p6rePlfqdDqdTqfT6XQ6nU6n0+l0CgCcxc+zmW1yMrf/R2IYGZE3I7VpBittwDHAjqRbkh73NL0j6bSZ3U1v1doDXNfNbNYY1uQBr8g/+JK0K+nlxLZko6YJmBJaFhWGigPsAw9GJOBjHgDPZLJtK5LwW5qWj0zS5US2ZKV4EgZWkm5KOj3x1l8kPWlm9+Nb9Q/bkIRf1PTBl6Q9SS/M/fC5IWbu/TVMwJyE2nwyLhqCgFOSfpa0GmhyuPl7auD6kdZh6HDg+hgbZidSF74QVdoD3tDw4EvS+5I+cFxfSXo9qkWZKeYBgEn6XtLQchJJZyT9JelHDdt6Q9LTZhb0JG+zB5zT8OBL0tdmdt3Mbkj6xtFuX9LzUS3LSMkJ8CXQ9wb+D+mrWoqEIGBX0m1Jjw00+deBG/6DunuSnjCz3wJs2coQdEnDgy9JH5087TSze5I+cbTfkfRqiCHmIfX9RQC+8+xf/ie64Bdrvk1k66yNVnWMGMhrjnsnT1wEe5NOQIkQ5EuYbzuuLTYZZwHYAX51PFB3gUFRBtgF/nDc/zvgyi0hNi/KA3yq12eulYyZ3ZH0heP+Rall0QEOPA/U+RF9XPD08VVkm5N6QDbwq14/sT6e8PVjwA+OfqKqZaknIGcI8qle74w5z9m0ueJqoohqWZPr/P8CrIBbjgfpPjBalAH2gD8d/R0Cj6b8Tk0BXPR48tWAPr/09HkxxXdpEuBq7MECXoo9qYuEROGCyGGtFDmS8GVJrgG+EvJmg5kdSfrQ0WQl6bWp/S4KEi8ZibS0XSzAecfgQIRNE/7N3bkY3yUVqUPQFNUrlH5A9zDIdHDGzAO+0qT0gEmqVygp1bKmIaN4QiG1rFpGDMig6jXjM7OrZTFIFYLmqF6h9GQslUuKFFDLYpDCA2apXqFs1LLPHU2qVMui7xKBA61fO6yRAzO7UNqIk0SdAGBf7hdpS4OkM2Z2vbQhx8QOQVNrvXJTXW1ZtMEivNYrN1lqy8YS0wNCa71yE6W2LBYxJ6CldXY1tkYJQcCe1rVerQjhR5KeMrPbpQ2J5QE+1as2lqOWkflFqQl2bYdaRgbVa4Zt1atlMUJQDtUrlGUf0FH5ARgNqGVzPcCnen2c65etHsZGLfvU0aRttQy/CHK2Ahuf89jYplpGAdUrlBEPSjG1bE4IKqF6hbKsZEwDye0kVLxYCPWAIqpXKIurLSNCrVduyFxblgwa3eJT6ZFJSAjyqV7vhv52T0py15YlgcaLImi9towEtV65oeXaMhLUeuWGVmvLaN19N1BZGJ2ShJPUeuWmydoyKl3ChUJrS2kqVr1CoRK1bGwIqln1CqWNAzoqPsiaA5UcKI7xgCy1XrlppraMisWMudBryzqdTqfT6XQ6nU6n0+l0Ohn5G65s4rZXjv6TAAAAAElFTkSuQmCC" />
    </defs>
  </svg>
);


const AdvancedConfigsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <rect y="0.441162" width="24" height="24" fill="url(#pattern1)" />
    <defs>
      <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_6_587" transform="scale(0.0104167)" />
      </pattern>
      <image id="image0_6_587" width="96" height="96" xlinkHref="data:image/png;base64,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" />
    </defs>
  </svg>
);

const useColorLibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
        'linear-gradient( 136deg, rgb(160 181 247) 0%, rgb(52 88 195) 50%, rgb(17 14 86) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
        'linear-gradient( 136deg, rgb(160 181 247) 0%, rgb(52 88 195) 50%, rgb(17 14 86) 100%)',
  },
});

const ColorLibStepIcon = ({ active, completed, icon }) => {
  const classes = useColorLibStepIconStyles();

  const icons = {
    1: <ColorLensIcon fontSize="large" />,
    2: <FontFormatIcon />,
    3: <AdvancedConfigsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(icon)]}
    </div>
  );
};

export default ColorLibStepIcon;
